import * as React from "react";
import { FormComponent } from "../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../react-core/Html/PartLoading";
import { RadiosEditor } from "../../../../../react-core/Html/RadiosEditor";
import { TransferBeneficalOwner } from "../../../../../Wrap/Models/Domains/Transfer/TransferBeneficalOwner";
import { TransferDestinationAccountModel } from "../../../../../Wrap/Models/Domains/Transfer/TransferDestinationAccountModel";
import { TransferSourceAccounts } from "../../../../../Wrap/Models/Domains/Transfer/TransferSourceAccounts";
import { ChangeOfBeneficialOwner as ChangeOfBeneficialOwnerModel } from "../../../../../Wrap/Models/Models/Transfer/ChangeOfBeneficialOwner";
import { TransferWizardAction } from "../../Actions/TransferWizardAction";
import { TransferInstructionQuery } from "../../Resources/TransferInstructionQuery";
import { ChangeOfBeneficialOwnerAccount } from "./ChangeOfBeneficialOwnerAccount";

interface IChangeOfBeneficialOwnerProps {
    data: TransferInstructionQuery;
    onChange: (key: string, value: any, data?: any) => void;
    isReview: boolean;
    destinationAccount: TransferDestinationAccountModel;
    currentAccount: TransferSourceAccounts;
    onRef: (ref) => void;
}

interface IChangeOfBeneficialOwnerState {
    beneficialOwners: TransferBeneficalOwner[];
}

export class ChangeOfBeneficialOwner extends FormComponent<
    IChangeOfBeneficialOwnerProps,
    IChangeOfBeneficialOwnerState
> {
    constructor(props: IChangeOfBeneficialOwnerProps) {
        super(props);
        this.state = {
            beneficialOwners: null,
        };
    }

    isValid() {
        const flag = this.beneficialOwners ? this.beneficialOwners.isValid() : true;
        return super.isValid() && flag;
    }

    componentDidMount() {
        const { currentAccount, destinationAccount, data, onChange, onRef } = this.props;
        onRef(this);
        TransferWizardAction.getBeneficialOwner(
            currentAccount?.HierarchyId,
            destinationAccount?.HierarchyId,
            (result) => {
                this.setState({ beneficialOwners: result });
                if (data.IsChangeOfBeneficial == null) {
                    onChange("ChangeOfBeneficialOwner", this.reset(result));
                }
            }
        );
    }

    private reset(data: TransferBeneficalOwner[]): ChangeOfBeneficialOwnerModel {
        if (!data || data.length == 0) {return;}

        const changeOfBnenficialOwner: ChangeOfBeneficialOwnerModel = {
            UseDestinationClientNationalIdentifier: false,
            UseSourceClientNationalIdentifier: false,
            UseSecondaryDestinationClientNationalIdentifier: false,
            UseSecondarySourceClientNationalIdentifier: false,
        };
        //source account
        (data[0]?.BeneficialOwners || []).forEach((ele) => {
            // primary customer
            if (ele.isPrimary) {
                if (ele.CustomerTaxResidencyModel && ele.CustomerTaxResidencyModel.length > 0) {
                    changeOfBnenficialOwner.UseSourceClientNationalIdentifier = true;
                }
            } else {
                if (ele.CustomerTaxResidencyModel && ele.CustomerTaxResidencyModel.length > 0) {
                    changeOfBnenficialOwner.UseSecondarySourceClientNationalIdentifier = true;
                }
            }
        });
        //destination account
        (data[1]?.BeneficialOwners || []).forEach((ele) => {
            // primary customer
            if (ele.isPrimary) {
                if (ele.CustomerTaxResidencyModel && ele.CustomerTaxResidencyModel.length > 0) {
                    changeOfBnenficialOwner.UseDestinationClientNationalIdentifier = true;
                }
            } else {
                if (ele.CustomerTaxResidencyModel && ele.CustomerTaxResidencyModel.length > 0) {
                    changeOfBnenficialOwner.UseSecondaryDestinationClientNationalIdentifier = true;
                }
            }
        });
        return changeOfBnenficialOwner;
    }

    private beneficialOwners;

    render() {
        const { data, onChange } = this.props;
        const { beneficialOwners } = this.state;
        return (
            <PartLoading isLoading={beneficialOwners == null}>
                <RadiosEditor
                    selected={data?.IsChangeOfBeneficial}
                    label={"Does the movement of any reportable assets represent a Change of Beneficial owner?"}
                    onChange={(v) => {
                        onChange("IsChangeOfBeneficial", v, this.reset(beneficialOwners));
                    }}
                    options={[true, false]}
                    required={"please confirm if the transaction represents a change in beneficial owner"}
                    cssWrapper="rg-inline mb-10"
                    getText={(o) => (o ? "Yes" : "No")}
                />
                {data?.IsChangeOfBeneficial && (
                    <ChangeOfBeneficialOwnerAccount
                        {...this.props}
                        onRef={(ref) => (this.beneficialOwners = ref)}
                        sourceAccount={beneficialOwners ? beneficialOwners[0] : null}
                        destinationAccount={beneficialOwners ? beneficialOwners[1] : null}
                    />
                )}
            </PartLoading>
        );
    }
}
